module.exports = __webpack_public_path__ + "img/2.119112c4.jpg";